(() => {
  customElements.get("media-gallery-mobile") || customElements.define("media-gallery-mobile", class extends HTMLElement {
    constructor() {
      super(), this.selectors = { container: ".m-main-product--wrapper", slider: ".swiper-container", sliderPagination: ".swiper-pagination", sliderPrevEl: ".swiper-button-prev", sliderNextEl: ".swiper-button-next", navSlider: ".nav-swiper-container", medias: [".m-product-media--item"], mediaWrapper: ".m-product-media--wrapper", mediaZoomIns: [".m-product-media__zoom-in"], videos: [".media-video"], variantIdNode: '[name="id"]', featuredImage: ".m-product-media" }, this.container = this.closest(this.selectors.container), this.domNodes = queryDomNodes(this.selectors, this), this.enableVideoAutoplay = "true" === this.dataset.enableVideoAutoplay, this.enableImageZoom = "true" === this.dataset.enableImageZoom, this.enableVariantGroupImages = "true" === this.dataset.enableVariantGroupImages, this.onlyMedia = "true" === this.dataset.onlyMedia, this.container && (this.view = this.container.dataset.view || "product-template"), this.section = this.closest(`[data-section-id="${this.sectionId}"]`), this.layout = this.dataset.layout;
      this.handleZoomClick = this.handleZoomClick.bind(this);
    }
    connectedCallback() {
      if (this.initialized) {
        this.initPhotoswipe();
        return;
      }
      this.setupData();
    }
    disconnectedCallback() {
      if (!this.zoomClickBound) return;
      this.removeEventListener("click", this.handleZoomClick);
      this.zoomClickBound = false;
    }
    async setupData() {
      if (this.initialized) return;
      this.productHandle = this.dataset.productHandle;
      this.productUrl = this.dataset.productUrl;
      this.productData = await this.getProductJson(this.productUrl);
      const variants = this.productData?.variants;
      const variantInput = this.container?.querySelector(this.selectors.variantIdNode);
      if (!this.productData || !Array.isArray(variants) || !variants.length || !variantInput) return;
      const fallbackVariantId = this.productData.selected_or_first_available_variant?.id || variants.find((variant) => variant.available)?.id || variants[0].id;
      const selectedVariantId = Number(variantInput.value) || fallbackVariantId;
      this.productData.initialVariant = variants.find((variant) => variant.id === selectedVariantId) || variants[0];
      if (!this.productData.selected_variant && variantInput.dataset.selectedVariant) {
        const selectedId = Number(variantInput.dataset.selectedVariant);
        this.productData.selected_variant = variants.find((variant) => variant.id === selectedId);
      }
      this.initialized = true;
      this.init();
    }
    init() {
      const variantPicker = this.container?.querySelector("variant-picker");
      this.handlePhotoswipe();
      this.initPhotoswipe();
      this.initSlider();
      this.handleAutoplayVideo();
      if (!variantPicker) {
        this.handleSlideChange();
        this.removeAttribute("data-media-loading");
        if (this.firstElementChild) this.firstElementChild.style.opacity = 1;
      }
    }
    initSlider() {
      if (!this.domNodes.slider) return;
      this.mediaMode = "slider";
      const { domNodes: { slider: e, sliderPagination: t, navSlider: i, sliderNextEl: s, sliderPrevEl: a } } = this;
      let o = 0, r = {}, l = {};
      this.productData.initialVariant && this.productData.selected_variant && this.productData.initialVariant.featured_media && (o = this.productData.initialVariant.featured_media.position - 1 || 0), r = { loop: false, initialSlide: o, slidesPerView: 5, freeMode: true, spaceBetween: 10, threshold: 2, watchSlidesVisibility: true, watchSlidesProgress: true, on: { init: () => i.style.opacity = 1 } }, this.navSlider = i ? new MinimogLibs.Swiper(i, r) : null;
      const d = this.navSlider ? { thumbs: { swiper: this.navSlider } } : {};
      l = { initialSlide: o, autoHeight: true, navigation: { nextEl: s, prevEl: a }, threshold: 2, loop: !this.enableVariantGroupImages, pagination: { el: t, clickable: true, type: "bullets" }, ...d, on: { init: () => {
        e.style.opacity = 1, this.domNodes = queryDomNodes(this.selectors, this.container);
      } } }, this.slider = new MinimogLibs.Swiper(e, l), this.enableVariantGroupImages || this.handleSlideChange();
    }
    handleSlideChange() {
      if (!this.slider || this.slideChangeBound) return;
      this.slideChangeBound = true;
      let e = true, t = "", i = [];
      this.slider.on("slideChange", ((s) => {
        window.pauseAllMedia(this);
        try {
          const { slides: a, activeIndex: o } = s;
          a[o] && this.playActiveMedia(a[o]), i = [o];
          for (let e2 of i) {
            const i2 = a[e2];
            if (i2 && (t = i2.dataset.mediaType), "model" === t) break;
          }
          "model" === t ? (this.slider.allowTouchMove = false, e = false) : (e || (this.slider.allowTouchMove = true), e = true);
        } catch (e2) {
        }
      }));
    }
    handleAutoplayVideo() {
      if (this.slider) {
        const { slides: e, activeIndex: t } = this.slider, i = e[t], s = i && i.dataset.mediaType;
        if ("video" === s || "external_video" == s) {
          const e2 = i.querySelector("deferred-media"), t2 = "true" === e2.dataset.autoPlay;
          e2 && t2 && e2.loadContent(false);
        }
      } else {
        const e = this.querySelectorAll(".m-product-media--item");
        e && e.forEach(((e2) => {
          const t = e2.dataset.mediaType;
          if ("video" === t || "external_video" === t) {
            const t2 = e2.querySelector("deferred-media"), i = "true" === t2.dataset.autoPlay;
            t2 && i && t2.loadContent(false);
          }
        }));
      }
    }
    playActiveMedia(e) {
      const t = e.querySelector("deferred-media");
      if (!t) return;
      if ("true" === t.dataset.autoPlay) if (t.getAttribute("loaded")) {
        const e2 = t.querySelector("video, model-viewer, iframe");
        if (e2.classList.contains("js-youtube")) {
          const t2 = e2.src.indexOf("?") > -1 ? "&" : "?";
          e2.src += t2 + "autoplay=1&mute=1";
        } else if (e2.classList.contains("js-vimeo")) {
          const t2 = e2.src.indexOf("?") > -1 ? "&" : "?";
          e2.src += t2 + "autoplay=1&muted=1";
        } else e2.play();
      } else {
        t.loadContent(false);
        const e2 = t.querySelector("video, model-viewer, iframe");
        if (e2.classList.contains("js-youtube")) {
          const t2 = e2.src.indexOf("?") > -1 ? "&" : "?";
          e2.src += t2 + "autoplay=1&mute=1";
        } else if (e2.classList.contains("js-vimeo")) {
          const t2 = e2.src.indexOf("?") > -1 ? "&" : "?";
          e2.src += t2 + "autoplay=1&muted=1";
        } else e2.play();
      }
    }
    handlePhotoswipe(e = []) {
      if (!this.enableImageZoom) return;
      const t = [], i = this.querySelectorAll(".m-product-media--item:not(.swiper-slide-duplicate)");
      i && i.forEach(((e2, i2) => {
        if ("image" === e2.dataset.mediaType) {
          const i3 = e2.querySelector(".m-product-media").dataset;
          t.push({ src: i3.mediaSrc, width: parseInt(i3.mediaWidth), height: parseInt(i3.mediaHeight), alt: i3.mediaAlt, id: e2.dataset.index });
        } else t.push({ html: `<div class="pswp__${e2.dataset.mediaType}">${e2.innerHTML}</div>`, type: e2.dataset.mediaType, id: e2.dataset.index });
      }));
      this.lightboxInitialized = false;
      this.lightbox = new MinimogLibs.PhotoSwipeLightbox({ dataSource: e.length > 0 ? e : t, bgOpacity: 1, close: false, zoom: false, arrowNext: false, arrowPrev: false, counter: true, preloader: true, pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe });
      this.lightbox.addFilter("thumbEl", ((e2, t2, i2) => {
        const s2 = this.querySelector('[data-index="' + t2.id + '"]:not(.swiper-slide-duplicate) img');
        return s2 || e2;
      })), this.lightbox.addFilter("placeholderSrc", ((e2, t2) => {
        const i2 = this.querySelector('[data-index="' + t2.data.id + '"]:not(.swiper-slide-duplicate) img');
        return i2 ? i2.src : e2;
      })), this.lightbox.on("change", (() => {
        if (window.pauseAllMedia(this), this.slider) {
          const e2 = this.lightbox.pswp.currIndex;
          this.enableVariantGroupImages ? this.slider.slideTo(e2, 100, false) : this.slider.slideToLoop(e2, 100, false);
        }
      })), this.lightbox.on("pointerDown", ((e2) => {
        "model" === this.lightbox.pswp.currSlide.data.type && e2.preventDefault();
      }));
      const s = { name: "m-close", order: 11, isButton: true, html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>', onClick: (e2, t2, i2) => {
        i2.close();
      } }, a = { name: "m-arrowNext", className: "sf-pswp-button--arrow-next", order: 12, isButton: true, html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>', onClick: (e2, t2, i2) => {
        i2.next();
      } }, o = { name: "m-arrowPrev", className: "sf-pswp-button--arrow-prev", order: 10, isButton: true, html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>', onClick: (e2, t2, i2) => {
        i2.prev();
      } };
      this.lightbox.on("uiRegister", (() => {
        this.lightbox.pswp.ui.registerElement(s), this.onlyMedia || (this.lightbox.pswp.ui.registerElement(o), this.lightbox.pswp.ui.registerElement(a));
      }));
    }
    initPhotoswipe() {
      if (!this.enableImageZoom || !this.lightbox) return;
      if (!this.lightboxInitialized) {
        this.lightbox.init();
        this.lightboxInitialized = true;
      }
      if (this.zoomClickBound) return;
      this.addEventListener("click", this.handleZoomClick);
      this.zoomClickBound = true;
    }
    handleZoomClick(event) {
      const mediaItem = event.target.closest(this.selectors.medias[0]);
      if (!mediaItem || !this.contains(mediaItem)) return;
      const isImage = mediaItem.classList.contains("media-type-image");
      const clickedZoom = event.target.closest(this.selectors.mediaZoomIns[0]);
      if (!isImage && !clickedZoom) return;
      event.preventDefault();
      const index = Number(mediaItem.dataset.index) || 0;
      this.lightbox.loadAndOpen(index);
    }
    setActiveMedia(e) {
      if (e && e.featured_media) {
        const t = e.featured_media.position || 0;
        this.slider && this.slider.wrapperEl && this.slider.slideToLoop(t - 1);
      }
    }
    scrollIntoView(e) {
      e.scrollIntoView({ behavior: "smooth" });
    }
    readEmbeddedProductJson() {
      const node = this.container?.querySelector('#productData[type="application/json"]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (error) {
        return null;
      }
    }
    waitForEmbeddedProductJson() {
      return new Promise((resolve) => {
        let attempts = 0;
        const read = () => {
          const data = this.readEmbeddedProductJson();
          if (data || attempts >= 40) {
            resolve(data);
            return;
          }
          attempts += 1;
          window.setTimeout(read, 50);
        };
        read();
      });
    }
    async getProductJson(productUrl) {
      const embedded = this.readEmbeddedProductJson();
      if (embedded) return embedded;
      try {
        const response = await fetch(`${productUrl}.js`, { credentials: "same-origin" });
        if (response.ok) return await response.json();
      } catch (error) {
      }
      return this.waitForEmbeddedProductJson();
    }
  });
})();
